import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
const _excluded = ["count", "until"];
import { hasOccurrenceBefore, hasRemainingOccurrence } from "./seriesOccurrence.mjs";
export function deleteRecurringEvent(adapter, originalEvent, occurrenceStart, scope) {
  switch (scope) {
    case 'this-and-following':
      {
        return applyRecurringDeleteFollowing(adapter, originalEvent, occurrenceStart);
      }
    case 'all':
      {
        return {
          deleted: [originalEvent.id]
        };
      }
    case 'only-this':
      {
        return applyRecurringDeleteOnlyThis(adapter, originalEvent, occurrenceStart);
      }
    default:
      {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI X Scheduler: The scope "${scope}" is not supported for recurring events. ` + 'Supported scopes are "all", "only-this", and "this-and-following". ' + 'Use one of the supported scope values.' : _formatErrorMessage(243, scope));
      }
  }
}

/**
 * Deletes a single occurrence by adding an EXDATE to the series.
 * Drops the whole series when excluding the occurrence would leave no occurrence.
 * @returns The updated list of events.
 */
export function applyRecurringDeleteOnlyThis(adapter, originalEvent, occurrenceStart) {
  const exDates = [...(originalEvent.dataTimezone.exDates ?? []), adapter.startOfDay(occurrenceStart)];
  if (!hasRemainingOccurrence(adapter, originalEvent, exDates)) {
    return {
      deleted: [originalEvent.id]
    };
  }
  return {
    updated: [{
      id: originalEvent.id,
      exDates
    }]
  };
}

/**
 * Deletes the edited occurrence and every following one by truncating the rule to end the day
 * before. Drops the whole series when no occurrence remains before the edited one.
 * @returns The updated list of events.
 */
export function applyRecurringDeleteFollowing(adapter, originalEvent, occurrenceStart) {
  if (!hasOccurrenceBefore(adapter, originalEvent, occurrenceStart)) {
    return {
      deleted: [originalEvent.id]
    };
  }
  const untilDate = adapter.addDays(adapter.startOfDay(occurrenceStart), -1);
  const _ref = originalEvent.dataTimezone.rrule,
    baseRule = _objectWithoutPropertiesLoose(_ref, _excluded);
  return {
    updated: [{
      id: originalEvent.id,
      rrule: _extends({}, baseRule, {
        until: untilDate
      })
    }]
  };
}